import {
	ReminderEntityTypeEnum,
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
	TimelineItemSubcategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { parseReminderData } from "web_myplann/NotificationCenter/Utils/parseReminderData";

export const isIdentificationDocumentItem = (
	item: TimelineItemResponseDTO,
): boolean => {
	if (
		item.category === TimelineItemCategoryEnum.IdentificationDocument ||
		item.subcategory ===
			TimelineItemSubcategoryEnum.ReminderIdentificationDocument
	) {
		return true;
	}
	if (item.category !== TimelineItemCategoryEnum.Notification) {
		return false;
	}
	if (
		item.subcategory ===
		TimelineItemSubcategoryEnum.IdentificationDocumentExpiry
	) {
		return true;
	}
	return (
		item.subcategory === TimelineItemSubcategoryEnum.ReminderTerm &&
		parseReminderData(item.data)?.entityType ===
			ReminderEntityTypeEnum.IdentificationDocument
	);
};
